import { getUser } from 'api/users'
import { useQuery } from 'react-query'
import { useParams } from 'react-router-dom'
import { UserType } from 'types'
import { UserAdminDetails } from '../UserAdminDetails/UserAdminDetails'
import { UserDetails } from '../UserDetails/UserDetails'

export function UserDetailsPage() {
  const { userId } = useParams()
  const userQuery = useQuery(['user', userId], () => getUser({ id: Number(userId) }))

  if (!userId) {
    return null
  }

  const isAdminOrAnalyst =
    userQuery.data?.data.type.includes(UserType.ADMIN) ||
    userQuery.data?.data.type.includes(UserType.ANALYST)

  if (isAdminOrAnalyst) {
    return <UserAdminDetails userId={Number(userId)} />
  }

  return <UserDetails userId={Number(userId)} />
}
